export default __webpack_public_path__ + "static/media/subscription.8ce3d152.png";